
import homeFloatingNavigation from "./home/index.js";
import ColumnDetail from "./column/_detail.js";
import rich from "./rich/index.js";
import staff from "./staff/_detail.js";
import voiceSlider from "./home/_voice.js";
import accessSlider from "./home/_access.js";
import heroSlider from "./home/_hero.js";
import searchArea from "./search/area.js";
import searchStation from "./search/station.js";
import searchSchool from "./search/school.js";
import SearchMap from "./search/map/index.js";
import estateIndex from "./estate/index.js";
import estateDetail from "./estate/detail.js";
import error from "./error/index.js";
import companyHistory from "./company/_index.js";
import flowAccordion from "./flow/_index.js";
import sellconsultationModalForm from "./sellconsultation/index.js";
const pages = () => {
    homeFloatingNavigation();
    ColumnDetail();
    rich();
    staff();
    voiceSlider();
    accessSlider();
    heroSlider();
    searchArea();
    searchStation();
    searchSchool();
    SearchMap();
    estateIndex();
    estateDetail();
    error();
    companyHistory();
    flowAccordion();
    sellconsultationModalForm();
};
export default pages;
